/**
 * Level 4: Sky
 * 
 * Introduces wind zones and magnetic boxes:
 * - Wind zones that push the player upward
 * - First magnetic box (floating: true)
 * - Sunset sky theme
 * - Challenging platforming sequences
 * 
 * @module configs/levels/Level04_Sky
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level04_Sky = {
    id: 4,
    name: 'Sky',
    subtitle: 'Above the Clouds',
    description: 'Master wind zones and magnetic boxes in the sky.',
    
    worldWidth: 5000,
    worldHeight: 1600,
    playerStart: { x: 100, y: 1300 },
    
    theme: {
        bgGradient: ['#ff6b6b', '#feca57'],
        platformColor: 0xffffff,
        accentColor: 0xFFD700,
        particleColor: 0xffffff
    },
    
    platforms: [
        { x: 0, y: 1400, w: 400, h: 50 },
        { x: 500, y: 1250, w: 150, h: 20 },
        { x: 800, y: 1100, w: 150, h: 20 },
        { x: 1100, y: 950, w: 200, h: 20 },
        { x: 1400, y: 1200, w: 300, h: 50 },
        { x: 1800, y: 1000, w: 150, h: 20 },
        { x: 2200, y: 850, w: 150, h: 20 },
        { x: 2600, y: 700, w: 200, h: 20 },
        { x: 3000, y: 1100, w: 300, h: 50 },
        { x: 3400, y: 900, w: 150, h: 20 },
        { x: 3800, y: 750, w: 150, h: 20 },
        { x: 4050, y: 650, w: 200, h: 20 },
        { x: 4500, y: 1000, w: 500, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 650, y: 1200, w: 100, h: 20, moveY: 100, speed: 0.005 },
        { x: 1550, y: 1100, w: 120, h: 20, moveX: 200, speed: 0.006 },
        { x: 2400, y: 800, w: 100, h: 20, moveY: 150, speed: 0.005 },
        { x: 3200, y: 850, w: 120, h: 20, moveX: 200, speed: 0.006 },
        { x: 4200, y: 900, w: 100, h: 20, moveY: 200, speed: 0.005 }
    ],
    
    spikes: [
        { x: 1500, y: 1200 },
        { x: 1550, y: 1200 },
        { x: 3100, y: 1100 },
        { x: 3150, y: 1100 },
        { x: 4600, y: 1000 },
        { x: 4650, y: 1000 }
    ],
    
    stars: [
        { x: 800, y: 1050 },
        { x: 1100, y: 900 },
        { x: 2200, y: 800 },
        { x: 2600, y: 650 },
        { x: 3400, y: 850 },
        { x: 4150, y: 550 },
        { x: 4700, y: 950 }
    ],
    
    enemies: [
        { x: 1500, y: 1150 },
        { x: 3050, y: 1050 },
        { x: 4600, y: 950 }
    ],
    
    door: { x: 4800, y: 850, w: 50, h: 300 },
    button: { x: 4600, y: 995 },
    box: { x: 4150, y: 600, floating: true }, // MAGNETIC BOX
    goal: { x: 4900, y: 900 },
    
    windZones: [
        { x: 2800, y: 500, w: 400, h: 300, direction: 'up', force: 0.003 }
    ],
    
    trampolines: [
        { x: 3000, y: 1100, w: 80 }
    ],
    
    speedrunTargets: { gold: 50, silver: 70, bronze: 95 }
};

export default Level04_Sky;
